import { apiClient } from 'client/core/network/apiClient';
import {
  IPDNDLogsQueryDto,
  IPDNDVerificationLog,
  IPDNDVerificationRequest
} from 'common/dto/PDNDVerificationDto';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import {
  RichiestaE002,
  RispostaE002OK
} from 'server/schema/integrations/pdnd/schema/schemas';

// PDND (C020)
export const NationalDataPlatformApi = {
  verification: (opts: { body: IPDNDVerificationRequest }) =>
    apiClient.post<RispostaE002OK>(
      `/national-data-platform/verification`,
      opts.body,
      {}
    ),
  listLogs: (opts: { query: IPDNDLogsQueryDto }) =>
    apiClient.get<PaginatedResult<IPDNDVerificationLog>>(
      `/national-data-platform/logs`,
      { params: opts.query }
    )
};
